const doc = [({"en":({"js":({"admin":({"user_elements":({"edit":({"update_answer":"Update answer", "the_answer_was_updated":"The answer was updated"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;